import {useContext} from "react";
import {CreateNewEntityContext} from "./CreateNewEntityContext";
import {CreateNewEntityController} from "./CreateNewEntityController";

/**
 * Custom hook to use the TestEntity context
 * Throws an error if used outside of CreateNewEntityProvider
 */
export function useCreateNewEntity(): CreateNewEntityController {
  const controller = useContext(CreateNewEntityContext);

  if (!controller) {
    throw new Error(
      "useCreateNewEntity must be used within a CreateNewEntityProvider"
    );
  }

  return controller;
}
